import { render, staticRenderFns } from "./VariableIndex.vue?vue&type=template&id=ac615b4c&scoped=true&"
import script from "./VariableIndex.vue?vue&type=script&lang=js&"
export * from "./VariableIndex.vue?vue&type=script&lang=js&"
import style0 from "./VariableIndex.vue?vue&type=style&index=0&id=ac615b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac615b4c",
  null
  
)

export default component.exports